import { render } from "./GameDetailPage.vue?vue&type=template&id=35081680&scoped=true"
import script from "./GameDetailPage.vue?vue&type=script&lang=js"
export * from "./GameDetailPage.vue?vue&type=script&lang=js"

import "./GameDetailPage.vue?vue&type=style&index=0&id=35081680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35081680"]])

export default __exports__